// Canister ID configuration for IC-SPICY project
// Based on actual deployed canisters

export const IC_SPICY_CANISTERS = {
  // Frontend
  assets: import.meta.env.VITE_ASSETS_CANISTER_ID || 'vmcfj-haaaa-aaaao-a4o3q-cai',
  
  // Existing Motoko canisters
  chili: import.meta.env.VITE_CHILI_CANISTER_ID || 'l3hu7-laaaa-aaaap-qp5mq-cai',
  profile: import.meta.env.VITE_PROFILE_CANISTER_ID || 'loafs-kiaaa-aaaap-qp5pa-cai',
  wallet: import.meta.env.VITE_WALLET_CANISTER_ID || 'o3yul-xiaaa-aaaap-qp5ra-cai',
  membership: import.meta.env.VITE_MEMBERSHIP_CANISTER_ID || 'laci2-ryaaa-aaaap-qp5oa-cai',
  portal: import.meta.env.VITE_PORTAL_CANISTER_ID || 'lhdoo-4aaaa-aaaap-qp5oq-cai',
  game: import.meta.env.VITE_GAME_CANISTER_ID || 'lvfzx-qqaaa-aaaap-qp5nq-cai',
  ai: import.meta.env.VITE_AI_CANISTER_ID || 'kriwf-jqaaa-aaaap-qp5lq-cai',
  blog: import.meta.env.VITE_BLOG_CANISTER_ID || 'l4gsl-gyaaa-aaaap-qp5ma-cai',
  shop: import.meta.env.VITE_SHOP_CANISTER_ID || 'ljbdg-hqaaa-aaaap-qp5pq-cai',
  user: import.meta.env.VITE_USER_CANISTER_ID || 'os37x-baaaa-aaaap-qp5qq-cai',
  whitepaper: import.meta.env.VITE_WHITEPAPER_CANISTER_ID || 'o4zs7-2qaaa-aaaap-qp5rq-cai',
  
  // New Rust canisters
  icspicy: import.meta.env.VITE_ICSPICY_CANISTER_ID || '',
  kip: import.meta.env.VITE_KIP_CANISTER_ID || '',
  treasury: import.meta.env.VITE_TREASURY_CANISTER_ID || '',
  limited_edition: import.meta.env.VITE_LIMITED_EDITION_CANISTER_ID || '',
};

// Legacy support
export const EXISTING_CANISTERS = IC_SPICY_CANISTERS;

// Helper to get canister ID with fallback
export function getCanisterId(name: keyof typeof IC_SPICY_CANISTERS): string {
  const envVar = `VITE_${name.toUpperCase()}_CANISTER_ID`;
  const envValue = import.meta.env[envVar];
  if (envValue && typeof envValue === 'string' && envValue.length > 0) {
    return envValue;
  }
  const canisterValue = IC_SPICY_CANISTERS[name];
  if (canisterValue && typeof canisterValue === 'string' && canisterValue.length > 0) {
    return canisterValue;
  }
  return '';
}

// Check if we're using IC-SPICY deployment
export const isICSpicyDeployment = () => {
  return IC_SPICY_CANISTERS.assets === 'vmcfj-haaaa-aaaao-a4o3q-cai' || 
         IC_SPICY_CANISTERS.chili === 'l3hu7-laaaa-aaaap-qp5mq-cai';
};

// Legacy support
export const isExistingDeployment = isICSpicyDeployment;

